import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 py-8 text-center border-t border-slate-900" data-id="element-20">
      <div className="max-w-4xl mx-auto px-4" data-id="element-21">
        <p className="text-slate-500 text-sm mb-4" data-id="element-22">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="text-slate-600 text-sm" data-id="element-23">
          © {new Date().getFullYear()} Redacción de Puntos Periciales PRO.
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}